<template>
  <div class="income">
    <div
      class="flex items-end justify-between gap-5 mb-6 mdmax:flex-col mdmax:items-start"
    >
      <div
        class="flex items-end gap-5 mdmax:flex-col mdmax:items-start mdmax:gap-3 mdmax:w-full"
      >
        <div class="w-60">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block"
            >Merchant</label
          >
          <CustomSelect
            :options="merchants"
            v-model="selectedMerchant"
            :default="selectedMerchant"
            optionLabel="merchant"
            @change="triggerDateChange()"
          />
        </div>
        <div
          class="flex items-end gap-5 mdmax:items-start mdmax:gap-3 mdmax:w-full"
        >
          <div class="w-40 mdmax:flex-1">
            <label
              class="text-sm text-neutral-700 font-medium mb-1 inline-block"
              >Bulan</label
            >
            <CustomSelect
              :options="monthList"
              v-model="selectedMonth"
              :default="selectedMonth"
              @change="triggerDateChange()"
            />
          </div>
          <div class="w-40 mdmax:flex-1">
            <label
              class="text-sm text-neutral-700 font-medium mb-1 inline-block"
              >Tahun</label
            >
            <CustomSelect
              :options="yearList"
              v-model="selectedYear"
              :default="selectedYear"
              @change="triggerDateChange()"
            />
          </div>
        </div>
        <div class="text-sm pb-3" v-if="paymentReports?.total">
          Total Dana Keluar:
          <span class="inline-block font-bold text-xl">{{
            paymentReports?.total | currencyFormat
          }}</span>
        </div>
      </div>
      <div class="flex items-end gap-5 mdmax:items-center mdmax:w-full">
        <Button
          buttonText="Export Data"
          size="big"
          @action="downloadReports()"
          :icon="() => import('@/components/Icons/Export')"
        />
      </div>
    </div>
    <div class="">
      <TableComponent :columns="columns" :list="filteredData" compact>
        <template slot="table-row" slot-scope="{ entry, column }">
          <div v-if="column.field === 'date'">
            {{ entry.date | formatDate }}
          </div>
          <div v-else-if="column.field === 'delivery_service'">
            <p>{{ entry.delivery_service }}</p>
            <p class="text-xs text-neutral-500">
              {{ entry.delivery_service_package }}
            </p>
          </div>
          <div v-else-if="column.field === 'transaction'">
            <p class="mb-1">
              {{ entry.package_origin }} - {{ entry.package_destination }}
            </p>
            <p class="text-xs text-neutral-500">
              AWB: {{ entry.package_shipment_awb }}
            </p>
          </div>
          <div v-else-if="column.field === 'payment_type'">
            <p>{{ entry.payment_type }}</p>
            <p class="text-xs text-neutral-500 capitalize">
              {{ entry.payment_bank }}
            </p>
          </div>
          <div v-else-if="column.field === 'payment_amount'">
            <strong>{{ entry.payment_amount | currencyFormat }}</strong>
          </div>
          <span v-else>{{ entry[column.field] || "-" }}</span>
        </template>
      </TableComponent>
      <template v-if="filteredData?.length > 0">
        <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">
          Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
        </div>
        <div
          class="mt-8 flex justify-end items-center mb-6"
          v-if="filteredData && filteredData.length > 0"
        >
          <pagination
            :currentPage="currentPage"
            :totalCount="totalRecords"
            :pageSize="pageSize"
            @onPageChange="onPageChange"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import dayjs from "dayjs"
import { formatDate, currencyFormat } from "@/util"
export default {
  filters: {
    formatDate,
    currencyFormat
  },
  components: {
    CustomSelect: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/CustomSelect"),
    TableComponent: () =>
      import(/* webpackChunkName: "Table" */ "@/components/Table/Table"),
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */ "@/components/Pagination/Pagination"
      ),
    Button: () =>
      import(/* webpackChunkName: "button" */ "@/components/Forms/Button")
  },
  data() {
    return {
      selectedYear: new Date().getFullYear(),
      selectedMonth: null,
      selectedMerchant: "",
      theMonths: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      tabList: [
        {
          title: "Semua",
          active: true
        },
        {
          title: "Dana Masuk",
          active: false
        },
        {
          title: "Dana Keluar",
          active: false
        }
      ],
      selectedTab: "",
      columns: [
        { label: "Tanggal", field: "date" },
        { label: "Pengiriman", field: "delivery_service" },
        { label: "Status", field: "package_shipment_status" },
        { label: "Transaksi", field: "transaction" },
        { label: "Pembayaran", field: "payment_type" },
        { label: "Biaya Ongkir", field: "payment_amount" }
      ],
      data: [
        {
          date: "16 Oct 2021",
          status: "Process",
          type: "Pengiriman",
          transaction: {
            orderId: "LN-5631",
            awb: "AWB: 878931904123789"
          },
          income: "+Rp 30.000",
          balance: "Rp 35.890.000"
        }
      ],
      searchTerm: "",
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      hasMorePages: true
    }
  },
  mounted() {
    const date = new Date()
    this.selectedMonth = this.theMonths[date.getMonth()]
    this.getListMerchant()
    // this.getReportList()
  },
  computed: {
    ...mapGetters("common", ["isMobile"]),
    ...mapGetters("summary", ["paymentReports"]),
    ...mapGetters("merchant", ["merchants"]),
    yearList() {
      return this.generateArrayOfYears()
    },
    monthList() {
      return this.theMonths
    },
    filteredData() {
      return this.paymentReports?.summary
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  methods: {
    ...mapActions("summary", ["getPaymentReports", "paymentReportsDownload"]),
    ...mapActions("merchant", ["getMerchants"]),
    ...mapActions("common", ["showLoading", "hideLoading"]),
    getListMerchant() {
      this.showLoading()
      this.getMerchants({
        params: {
          page: 1,
          per_page: 1000
        }
      })
        .then((res) => {
          this.hideLoading()
          this.selectedMerchant = this.merchants && this.merchants[0]
          this.getReportList()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    downloadReports() {
      const dateParams = this.getDateFromMonth(
        this.theMonths.indexOf(this.selectedMonth),
        this.selectedYear
      )
      this.paymentReportsDownload({
        params: {
          start_date: dateParams.startDate,
          end_date: dateParams.endDate,
          merchant_group_id: this.selectedMerchant.merchant_group_id
        }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement("a")
        link.href = url
        link.setAttribute(
          "download",
          `Payment Report - ${this.selectedMonth} ${this.selectedYear}.csv`
        )
        document.body.appendChild(link)
        link.click()
      })
    },
    triggerDateChange() {
      this.getReportList()
    },
    getReportList(page = 1) {
      const dateParams = this.getDateFromMonth(
        this.theMonths.indexOf(this.selectedMonth),
        this.selectedYear
      )
      this.showLoading()
      this.getPaymentReports({
        params: {
          page: page,
          per_page: this.pageSize,
          sort: "DESC",
          start_date: dateParams.startDate,
          end_date: dateParams.endDate,
          merchant_group_id: this.selectedMerchant.merchant_group_id
        }
      }).then((res) => {
        if (res.data.data) {
          this.totalRecords = res.data.meta.total_item
        }
        this.hideLoading()
      })
    },
    getDateFromMonth(month, year) {
      const date = new Date()
      const firstDay = dayjs(String(new Date(year, month, 1))).format(
        "YYYY-MM-DD"
      )
      const lastDay = dayjs(String(new Date(year, month + 1, 0))).format(
        "YYYY-MM-DD"
      )
      return {
        startDate: firstDay,
        endDate: lastDay
      }
    },
    selectTab(tab) {
      this.tabList.forEach((item) => (item.active = false))
      const tabIndex = this.tabList.findIndex(
        (item) => item.title === tab.title
      )
      this.tabList[tabIndex].active = true
      this.selectedTab = tab
    },
    onPageChange(page) {
      this.currentPage = page
      this.getReportList(page)
    },
    generateArrayOfYears() {
      var max = new Date().getFullYear()
      var min = max - 9
      var years = []
      for (var i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    }
  }
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: "";
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
